import { Component } from '@angular/core';
import packageJson from '../../package.json';
import { environment } from "../environments/environment";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {

  constructor() {
  }

  ngOnInit(): void {
    console.log(packageJson.version)
    console.log(environment.name)
  }


}
